"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Magic = void 0;

var _reactIcons = require("react-icons");

var MagicJson = {
  tag: "svg",
  attr: {
    viewBox: "0 0 32 32"
  },
  child: [{
    tag: "path",
    attr: {
      d: "M28.6659 20.6665L26.9997 17.4375L25.3335 20.6665L21.9998 22.2812L25.3335 23.896L26.9997 27.125L28.6659 23.896L31.9996 22.2812L28.6659 20.6665ZM26.9997 23.25C26.4472 23.25 25.9997 22.8165 25.9997 22.2812C25.9997 21.746 26.4472 21.3125 26.9997 21.3125C27.5522 21.3125 27.9997 21.746 27.9997 22.2812C27.9997 22.8165 27.5522 23.25 26.9997 23.25ZM13.9999 5.8125L14.9999 3.875L16.9998 2.90625L14.9999 1.9375L13.9999 4.2748e-07L12.9999 1.9375L10.9999 2.90625L12.9999 3.875L13.9999 5.8125ZM24.9997 11.625C25.5522 11.625 25.9997 11.1915 25.9997 10.6562V8.96336L31.7415 2.79787C32.099 2.41522 32.084 1.82791 31.7071 1.46281L30.4896 0.283965C30.3968 0.193842 30.2865 0.122364 30.1651 0.0736342C30.0437 0.024904 29.9136 -0.000119281 29.7821 4.2748e-07C29.5421 4.2748e-07 29.3022 0.0829497 29.1115 0.250059L11.6624 15.5H8.99995C8.44746 15.5 7.99997 15.9335 7.99997 16.4688V18.7011L0.6582 25.1173C-0.189913 25.8608 -0.223037 27.1407 0.585701 27.9242L3.17504 30.4327C3.56628 30.8123 4.07815 31 4.58877 31C5.13313 31 5.67625 30.7863 6.07187 30.3624L23.521 11.625H24.9997ZM4.58939 29.0625L1.99818 26.5559L28.459 3.42998L4.58939 29.0625ZM5.00001 9.6875L6.66624 6.45854L9.99994 4.84375L6.66624 3.22897L5.00001 4.2748e-07L3.33378 3.22897L8.42794e-05 4.84375L3.33378 6.45854L5.00001 9.6875ZM5.00001 3.875C5.5525 3.875 6 4.30852 6 4.84375C6 5.37898 5.5525 5.8125 5.00001 5.8125C4.44752 5.8125 4.00003 5.37898 4.00003 4.84375C4.00003 4.30852 4.44752 3.875 5.00001 3.875Z"
    },
    child: []
  }]
};

var Magic = function Magic(props) {
  return (0, _reactIcons.GenIcon)(MagicJson)(props);
};

exports.Magic = Magic;